export default {
  methods: {
    currency(value, precision) {
      if (value === null || typeof value === 'undefined') {
        value = 0
      }
      value = parseFloat(value)

      return `${value
        .toFixed(precision)
        .replace('.', ',')
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')} €`
    },
    remove_currency(value) {
      if (typeof value === 'undefined' || value === null) {
        return 0
      }
      value = value.toString().replace(/[^\d,\\.]/g, '')
      value = value.toString().replace(',', '.')

      return value.includes('.') ? parseFloat(value) : parseInt(value)
    },
  },
}
